export function preloadImage(url: string): void {
  const img = new Image();
  img.src = url;
}
